/**
 * Dahili sayfa yolları — Hero CTA, header CTA vb. için ortak liste.
 */
export const SITE_INTERNAL_PATH_OPTIONS = [
  { path: '/', label: 'Ana sayfa' },
  { path: '/about', label: 'Hakkımızda' },
  { path: '/contact', label: 'İletişim' },
  { path: '/portfolio', label: 'Referanslar' },
  { path: '/#contact-form', label: 'Ana sayfa — iletişim formu (bölüm)' },
]

export const SITE_INTERNAL_PATH_SET = new Set(SITE_INTERNAL_PATH_OPTIONS.map((o) => o.path))

/**
 * @param {string} path
 * @param {string} [fallback='/contact']
 */
export function normalizeSiteInternalPath(path, fallback = '/contact') {
  const p = String(path ?? '').trim()
  if (SITE_INTERNAL_PATH_SET.has(p)) return p
  return fallback
}
